import { Title, TitleOrder } from "@mantine/core";
import React, { ReactNode } from 'react';
interface TitleProps{
    title?: string | ReactNode;
    order?: TitleOrder;
    mb?:number;
    color?:string;
    className?:string;
    mt?:number
    children?:React.ReactNode;
    ml?:number;
    fz?:string;
    style?: React.CSSProperties;
    size?:string;
}
const CustomTitle=({title='',order=4,mb=0,color='',className='',mt=0,children,ml=0,fz='',style,}:TitleProps)=>{
    return(
        <>
        <Title order={order} mb={mb} ml={ml} c={color} mt={mt} fz={fz} style={style}  className={className}>{title}</Title>
        {children}
        </>
    )
}
export default CustomTitle;
